import React, { useState, useEffect } from 'react';
import { portalAgreementAPI } from '../../services/agreementAPI';
import './PlatformAgreementModal.css';

interface Props {
  onAccepted: () => void;
}

const PlatformAgreementModal: React.FC<Props> = ({ onAccepted }) => {
  const [content, setContent] = useState('');
  const [title, setTitle] = useState('Platform Agreement');
  const [version, setVersion] = useState('');
  const [agreed, setAgreed] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const load = async () => {
      try {
        const data = await portalAgreementAPI.getPlatformAgreement();
        setContent(data.content || '');
        setTitle(data.title || 'Platform Agreement');
        setVersion(data.version || '');
      } catch {
        // If can't load agreement, don't block
        onAccepted();
      }
    };
    load();
  }, [onAccepted]);

  const handleAccept = async () => {
    setSubmitting(true);
    setError('');
    try {
      await portalAgreementAPI.acceptPlatformAgreement();
      onAccepted();
    } catch (err: any) {
      setError(err.response?.data?.error || 'Failed to accept. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  if (!content) {
    return null;
  }

  return (
    <div className="agreement-modal-overlay">
      <div className="agreement-modal">
        <div className="agreement-modal-header">
          <h2>{title}</h2>
          {version && <p>Version {version}</p>}
        </div>

        <div
          className="agreement-modal-body"
          dangerouslySetInnerHTML={{ __html: content }}
        />

        <div className="agreement-modal-footer">
          {error && <div className="agreement-error">{error}</div>}

          <div className="agreement-checkbox-row">
            <input
              type="checkbox"
              id="agreement-accept-check"
              checked={agreed}
              onChange={e => setAgreed(e.target.checked)}
            />
            <label htmlFor="agreement-accept-check">
              I have read, understand, and agree to the terms of this agreement.
            </label>
          </div>

          <button
            className="agreement-accept-btn"
            onClick={handleAccept}
            disabled={!agreed || submitting}
          >
            {submitting ? 'Accepting...' : 'Accept & Continue'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlatformAgreementModal;
